import intl from 'react-intl-universal';
import { deleteCardLocal } from '../../../../state/normalized/dashboard/cardSlice';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useAppThunkDispatch } from '../../../../state/store';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import React, { useContext, useState } from 'react';
import { GridItemData } from './GridItem';
import { DashboardContext } from '../../DashboardContext';
import DeleteInsightModal from '../../../../Organisms/DeleteInsightModal/DeleteInsightModal';

export const DeleteCardOverflowItem = (props: {
  gridItemData: GridItemData;
}) => {
  const dispatch = useAppThunkDispatch();
  const { dashboardId } = useContext(DashboardContext);
  const [showModal, setShowModal] = useState(false);

  const { gridItemData } = props;

  const item = {
    label: intl.get('DASHBOARD_DETAIL.ACTION.DELETE'),
    iconName: 'trash-outline',
    onSelect: () => setShowModal(true),
    action: DASHBOARD_DETAIL_ACTIONS.DELETE,
  };

  function handleRemoveItemFromGrid() {
    if (!gridItemData.cardId) return;
    dispatch(
      deleteCardLocal({
        dashboardId: dashboardId,
        idOrLid: gridItemData.cardId,
      })
    );
  }

  return (
    <>
      <DeleteInsightModal
        gridId={gridItemData.gridId}
        insightName={gridItemData.name}
        deleteInsight={handleRemoveItemFromGrid}
        shouldDisplayModal={showModal}
        onCloseModal={() => setShowModal(false)}
      />
      <OverflowMenuItem
        key={item.label}
        className='flex items-center space-x-2'
        onSelect={item.onSelect}
        data-cy={`insight-${gridItemData.cardTypeId}__actions-popover__${item.action}`}
      >
        <Icon
          name={item.iconName || ''}
          className={tailwindOverride(
            'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg'
          )}
        />
        <Typography
          variant='label'
          className='group-hover:text-secondary-darker cursor-pointer'
        >
          {item.label}
        </Typography>
      </OverflowMenuItem>
    </>
  );
};
